document.addEventListener('DOMContentLoaded', function () {
    let cases = document.querySelectorAll('.uc-case');
    cases.forEach(function (card) {
        card.addEventListener('click', function () {
            if (this.classList.contains('uc-case--active')) return;
            let id = this.getAttribute('data-id');
            document.querySelectorAll('.uc-case').forEach(function (el) { el.classList.remove('uc-case--active'); });
            document.querySelectorAll('.uc-case-right .uc-case-right-item').forEach(function (el) { el.classList.remove('uc-case--active'); });
            this.classList.add('uc-case--active');
            let rightItem = document.querySelector('.uc-case-right .uc-case-right-item[id="' + id + '"]');
            if (rightItem) rightItem.classList.add('uc-case--active');
        });
    });
});


document.addEventListener('click', function (e) {
    let target = e.target instanceof Element ? e.target : null;
    if (!target) return;
    let trigger = target.closest('.js-video-play, .js-video-poster');
    if (!trigger) return;
    let container = trigger.closest('.js-video-container');
    if (!container || container.classList.contains('js-video-container--playing')) return;
    let video = (container.querySelector('video.js-video-video'));
    let iframe = (container.querySelector('iframe.js-video-video'));
    let mediaEl = video || iframe;
    if (!mediaEl) return;
    container.classList.add('js-video-container--playing');
    if (container.classList.contains('hp-video-banner__video-container')) {
        container.classList.remove('has-thumbnail');
        container.classList.add('no-thumbnail');
        container.querySelectorAll('.js-video-poster, .js-video-play').forEach(function (el) { el.classList.add('hidden'); });
    } else if (container.classList.contains('process-video')) {
        container.classList.add('playing');
    } else if (container.classList.contains('voices-card__video-wrap')) {
        container.querySelectorAll('.voices-card__video-thumb').forEach(function (el) { el.classList.add('voices-card__video-thumb--hidden'); });
        container.querySelectorAll('.voices-card__video-placeholder').forEach(function (el) { el.classList.add('voices-card__video-placeholder--hidden'); });
        container.querySelectorAll('.js-video-play').forEach(function (el) { el.classList.add('voices-card__play-btn--hidden'); });
    }
    mediaEl.style.opacity = '1';
    mediaEl.style.pointerEvents = 'auto';
    if (video) {
        video.play();
        video.controls = true;
    } else if (iframe) {
        let src = iframe.getAttribute('data-src');
        if (src) {
            iframe.src = src.indexOf('?') !== -1 ? src + '&autoplay=1' : src + '?autoplay=1';
        }
    }
});

(function () {
    const MODAL_SELECTOR = '#subscription-info-modal';
    const WRAPPER_SELECTOR = '.product-information__wrapper';
    const OPTION_SELECTOR = '.shopify_subscriptions_purchase_option_wrapper';
    let modalEnabled = false;

    function isSubscriptionOption(wrapper, label) {
        if (!wrapper || !label) return false;

        const hasPlanChildren = Boolean(wrapper.querySelector('.shopify_subscriptions_app_block_label_children'));
        const labelText = (label.textContent || '').toLowerCase();

        return hasPlanChildren || labelText.includes('subscribe') || labelText.includes('delivery');
    }

    function openModal() {
        const modal = document.querySelector(MODAL_SELECTOR);
        if (!modal) return;
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('subscription-info-modal-open');
    }

    function closeModal() {
        const modal = document.querySelector(MODAL_SELECTOR);
        if (!modal) return;
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('subscription-info-modal-open');
    }

    function injectIcons(scope) {
        const root = scope || document;
        const wrappers = root.querySelectorAll(OPTION_SELECTOR);

        wrappers.forEach(function (wrapper) {
            if (!modalEnabled) return;
            const label = wrapper.querySelector(':scope > label') || wrapper.querySelector('label');
            if (!isSubscriptionOption(wrapper, label)) return;
            if (wrapper.querySelector('.subscription-info-trigger')) return;

            wrapper.classList.add('subscription-option-with-info');

            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'subscription-info-trigger';
            button.setAttribute('aria-label', 'Subscription details');
            button.innerHTML = 'i';

            wrapper.appendChild(button);
        });
    }

    document.addEventListener('click', function (event) {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        if (target.closest('.subscription-info-trigger')) {
            event.preventDefault();
            openModal();
            return;
        }

        if (target.closest('[data-subscription-modal-close], .js-subscription-modal-close')) {
            event.preventDefault();
            closeModal();
        }
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            closeModal();
        }
    });

    document.addEventListener('DOMContentLoaded', function () {
        const subscriptionRoot = document.querySelector(WRAPPER_SELECTOR);
        modalEnabled = Boolean(document.querySelector(MODAL_SELECTOR));
        if (!modalEnabled) return;
        injectIcons(document);
        if (!subscriptionRoot) return;

        const observer = new MutationObserver(function () {
            injectIcons(subscriptionRoot);
        });

        observer.observe(subscriptionRoot, { childList: true, subtree: true });
    });
})();
